import React from 'react'
import classnames from 'classnames'

import { formatImageURL } from 'src/lib/js/utilities'
import Image from 'shared/components/common/Image'
import { ToastImageSet } from '../../MenuItemImage'
import { t } from 'src/translations'

type Props = {
  imageSetUrls: ToastImageSet[]
  activeIndex: number
  onThumbnailClick: (index: number) => void
}

export const ThumbnailGallery = ({
  imageSetUrls,
  activeIndex,
  onThumbnailClick
}: Props) => {
  // Only render if there are multiple images
  if (imageSetUrls.length <= 1) {
    return null
  }

  return (
    <div className='thumbnailGallery'>
      <div className='thumbnailScrollContainer'>
        {imageSetUrls.map((imageSet, index) => {
          const thumbnailSrc = imageSet.small ?? imageSet.xs ?? imageSet.medium
          // Include index in key to guarantee uniqueness even if URLs are identical
          const imageKey = thumbnailSrc
            ? `${thumbnailSrc}-${index}`
            : `image-${index}`
          return (
            <button
              key={imageKey}
              className={classnames('thumbnail', {
                active: index === activeIndex
              })}
              onClick={() => onThumbnailClick(index)}
              aria-label={t('product-display.gallery.view-image', {
                index: index + 1
              })}
              aria-current={index === activeIndex ? 'true' : undefined}
              type='button'
            >
              <Image
                src={thumbnailSrc ? formatImageURL(thumbnailSrc) : ''}
                alt=''
                className='thumbnailImage'
              />
            </button>
          )
        })}
      </div>
    </div>
  )
}
